import { render, staticRenderFns } from "./Forestal.vue?vue&type=template&id=0fb20cb2"
import script from "./Forestal.vue?vue&type=script&lang=js"
export * from "./Forestal.vue?vue&type=script&lang=js"
import style0 from "./Forestal.vue?vue&type=style&index=0&id=0fb20cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports